export enum MessageType {
    MyComments, MyReplies, System, FakeSystem
}

export interface MessageInterface {
    id: string;
    timestamp: string;
    type: MessageType;
    content: string;
    cid: number,
    user: {
        id: string;
        name: string;
        avatar: string;
        role: string;
        level: number;
        isOfficalUp: boolean;
        userLevelSymbol: string;
        gid: number;
        userKey: string;
    };
    video: {
        title: string;
        key: string;
        vid: number;
    };
    comment: {
        id: string;
        likes: number;
        isLike: boolean,
        reply: {
            title: string;
            content: string;
        }
        voteId: number
    };
}
